export default __webpack_public_path__ + "static/ak-cached/24h/media/WifiSecurityCamera.598a4d7b.png";